(() => {
  if(customElements.get('matilde-navigation')) return;
  customElements.define('matilde-navigation',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.abort=new AbortController();const options={signal:this.abort.signal};
      this.mobile=this.dataset.mode==='mobile';this.accordion=this.mobile;this.drawer=this.closest('#NavDrawer');
      if(this.dataset.mode==='shortcuts'){
        const list=this.querySelector('.mn-list');
        if(list&&this.closest('#SiteHeader')){
          const key='matilde-shortcuts-scroll';
          let saved=0;
          try{saved=Number(sessionStorage.getItem(key))||0;}catch{}
          const restore=()=>{if(list.isConnected)list.scrollLeft=saved;};
          restore();requestAnimationFrame(restore);
          document.fonts?.ready.then(restore);
          const save=()=>{saved=list.scrollLeft;try{sessionStorage.setItem(key,String(saved));}catch{}};
          list.addEventListener('scroll',save,{...options,passive:true});
          list.addEventListener('click',save,options);
        }
        const currentView=new URLSearchParams(location.search).get('view')||'';
        this.querySelectorAll('a[href]').forEach(link=>{
          const target=new URL(link.href,location.href);
          if(target.pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'')&&(target.searchParams.get('view')||'')===currentView)link.setAttribute('aria-current','page');
          else link.removeAttribute('aria-current');
        });
      }
      this.roots=[...this.querySelectorAll('.mn-details')];
      if(this.mobile&&!this.accordion){
        this.classList.add('mn-enhanced');this.viewport=this.querySelector('.mn-viewport');this.root=this.querySelector('.mn-root');
        this.roots.forEach(d=>{const panel=d._panel||d.querySelector('.mn-subpanel');if(!panel)return;this.viewport.append(panel);panel.inert=true;panel.setAttribute('aria-hidden','true');d._panel=panel;});
      }
      this.addEventListener('click',e=>{
        const summary=e.target.closest('.mn-details>summary');
        if(summary&&this.contains(summary)){
          const d=summary.parentElement;
          if(this.mobile&&!this.accordion){e.preventDefault();this.openPanel(d);}
          else this.roots.forEach(other=>{if(other!==d)other.open=false;});
        }
        if(e.target.closest('[data-mn-back]'))this.back();
        if(e.target.closest('a[href]')){
          if(this.mobile)window.theme?.NavDrawer?.close();
          else this.roots.forEach(d=>d.open=false);
        }
      },options);
      this.addEventListener('toggle',e=>{if(e.target.matches('details'))e.target.querySelector('summary')?.setAttribute('aria-expanded',String(e.target.open));}, {...options,capture:true});
      this.addEventListener('keydown',e=>{
        if(e.key==='Escape'&&!this.mobile){this.roots.forEach(d=>{if(d.open){d.open=false;d.querySelector('summary').focus();}});e.stopPropagation();}
        if(this.drawer&&e.key==='Tab'&&this.drawer.classList.contains('drawer--is-open')){
          const controls=[...this.drawer.querySelectorAll('button,a[href],summary,input,[tabindex="0"]')].filter(el=>!el.closest('[inert]')&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
          const first=controls[0],last=controls.at(-1);
          if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
          else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
        }
      },options);
      document.addEventListener('click',e=>{if(!this.mobile&&!this.contains(e.target))this.roots.forEach(d=>d.open=false);},options);
      if(this.drawer){
        this.observer=new MutationObserver(()=>{
          const open=this.drawer.classList.contains('drawer--is-open');
          document.documentElement.classList.toggle('mn-drawer-open',open);
          if(!open)this.back(false);
        });this.observer.observe(this.drawer,{attributes:true,attributeFilter:['class']});
        this.drawer.addEventListener('keydown',e=>{
          if(e.key!=='Tab'||e.target.closest('matilde-navigation'))return;
          const controls=[...this.drawer.querySelectorAll('button,a[href],summary,input,[tabindex="0"]')].filter(el=>!el.closest('[inert]')&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
          if(e.shiftKey&&document.activeElement===controls[0]){e.preventDefault();controls.at(-1)?.focus();}
          else if(!e.shiftKey&&document.activeElement===controls.at(-1)){e.preventDefault();controls[0]?.focus();}
        },options);
      }
      this.resize=()=>{if(this.mobile&&matchMedia('(min-width:769px)').matches)window.theme?.NavDrawer?.close();};window.addEventListener('resize',this.resize,options);
    }
    openPanel(d){
      this.back(false);this.active=d;const p=d._panel;this.classList.add('mn-in-submenu');this.root.inert=true;this.root.setAttribute('aria-hidden','true');
      d.querySelector('summary').setAttribute('aria-expanded','true');p.inert=false;p.setAttribute('aria-hidden','false');p.classList.add('is-active');
      this.viewport.style.minHeight=`${Math.max(p.scrollHeight,480)}px`;this.drawer?.querySelector('.drawer__scrollable')?.scrollTo(0,0);p.querySelector('button')?.focus({preventScroll:true});
    }
    back(focus=true){
      if(!this.mobile||this.accordion||!this.root)return;const active=this.active;
      this.querySelectorAll('.mn-subpanel').forEach(p=>{p.classList.remove('is-active');p.inert=true;p.setAttribute('aria-hidden','true');});
      this.classList.remove('mn-in-submenu');this.root.inert=false;this.root.removeAttribute('aria-hidden');this.viewport.style.minHeight='';
      if(active){active.querySelector('summary').setAttribute('aria-expanded','false');if(focus)active.querySelector('summary').focus({preventScroll:true});}this.active=null;
    }
    disconnectedCallback(){this.back(false);this.abort?.abort();this.observer?.disconnect();if(this.drawer)document.documentElement.classList.remove('mn-drawer-open');this.ready=false;}
  });
})();
